export default __webpack_public_path__ + "static/media/gwPlaceholder.84b4021b.png";